<template>
  <div class="sky-page-function-view">
    <div class="page-function-toolbar wsp-width-100">
      <el-button icon="el-icon-refresh" @click="searchReq"></el-button>
      <el-input
        placeholder="请输入功能名称/价值"
        class="toolbar-input"
        size="medium"
        v-model="searchKeyword"
        @blur="searchReq"
        @change="searchReq"
      >
        <span slot="suffix" class="el-input__suffix" @click="searchReq"
          ><span class="el-input__suffix-inner"> <i class="el-input__icon el-icon-search"></i></span>
        </span>
      </el-input>
      <el-dropdown trigger="click" v-if="!isChannel">
        <el-button>友商过滤<i class="el-icon-arrow-down el-icon--right"></i></el-button>
        <el-dropdown-menu slot="dropdown">
          <el-checkbox-group
            v-model="filterCompetitorList"
            style="display:inline-grid;margin-left: 10px;"
            @change="handleFilterCompetitorList"
          >
            <el-checkbox
              style="display: block; margin: 0;"
              v-for="(item, index) in initCompetitorList"
              :label="item.id"
              :key="index"
              >{{ item.label }}</el-checkbox
            >
          </el-checkbox-group>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-table
      ref="function_table"
      :border="true"
      :data="viewFeatureList"
      :show-header="true"
      :column-drag-sortable="false"
      :key="params.id"
      class="sky-host-dist"
      @select="selectionChange"
      @select-all="selectAllChange"
      height="50vh"
    >
      <!-- @selection-change="allSelectionChange" -->
      <el-table-column type="selection" width="55" :selectable="selectableReq" fixed> </el-table-column>
      <el-table-column
        align="center"
        fixed
        :label="$t('pocMng.functionList.featureName')"
        prop="name"
        width="215"
        show-overflow-tooltip
      >
        <div class="wsp-display-flex" slot-scope="scope" @click="showFuncDetail(scope.row)">
          <div class="sk-link--normal">{{ scope.row.featureName }}</div>
        </div>
      </el-table-column>
      <el-table-column
        align="center"
        label="功能类型"
        prop="featureType"
        width="85"
        :filter-method="filterFeatureType"
        :filters="[
          {
            text: '推荐',
            value: 'RECOMMEND'
          },
          {
            text: '必选',
            value: 'REQUIRED'
          },
          {
            text: '可选',
            value: 'OPTIONAL'
          }
        ]"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.featureType === 'REQUIRED'" type="warning">必选</el-tag>
          <el-tag v-if="scope.row.featureType === 'RECOMMEND'" type="primary">推荐</el-tag>
          <el-tag v-else type="success">可选</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        min-width="215"
        :label="$t('pocMng.functionList.sceneName')"
        :filter-method="filterSceneName"
        :filters="sceneNameList"
        show-overflow-tooltip
        prop="supportScene"
      >
        <template slot-scope="scope">
          <div v-for="(item, index) in scope.row.supportScene" :key="index">{{ item.name }}</div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        min-width="155"
        :label="$t('pocMng.functionList.valueDesc')"
        :filter-method="filterValueDesc"
        :filters="valueDescList"
        show-overflow-tooltip
        prop="valueDesc"
      >
      </el-table-column>
      <template v-if="!isChannel">
        <el-table-column
          align="center"
          show-overflow-tooltip
          :prop="versionItem.id"
          width="195"
          v-for="(versionItem, index) in productVersionList"
          :label="versionItem.productVersion"
          :key="index"
        >
          <el-table-column
            label="支持"
            align="center"
            width="`${filterCompetitorList && filterCompetitorList.length > 0 ? '70' : '215'}`"
            fixed="right"
          >
            <template slot-scope="scope">
              <div
                :class="
                  `font-size-20 ${
                    validateSupportInfo(scope.row, versionItem) ? 'wsp-icon-yes bg-3bb113 ' : 'wsp-icon-no bg-f13131'
                  }`
                "
              ></div>
            </template>
          </el-table-column>
          <el-table-column
            :label="competitor.label"
            :prop="competitor.id"
            width="95"
            align="center"
            v-for="(competitor, competitorIndex) in formCompetitorList"
            show-overflow-tooltip
            :key="competitorIndex"
          >
            <template slot-scope="scope">
              <el-tag
                v-if="
                  getCompetitivenessByFeatureAndProduct(
                    competitor.id,
                    scope.row.featureName,
                    versionItem.productVersion,
                    '优势'
                  )
                "
                type="success"
                >优</el-tag
              >
              <el-tag
                v-else-if="
                  getCompetitivenessByFeatureAndProduct(
                    competitor.id,
                    scope.row.featureName,
                    versionItem.productVersion,
                    '劣势'
                  )
                "
                type="warning"
                >劣</el-tag
              >
              <span
                v-else-if="
                  getCompetitivenessByFeatureAndProduct(
                    competitor.id,
                    scope.row.featureName,
                    versionItem.productVersion,
                    '持平'
                  )
                "
                >平</span
              >
              <span v-else>无</span>
            </template>
          </el-table-column>
        </el-table-column>
      </template>
      <template v-else>
        <el-table-column
          align="center"
          show-overflow-tooltip
          :prop="versionItem.id"
          width="195"
          v-for="(versionItem, index) in productVersionList"
          :label="versionItem.productVersion"
          :key="index"
        >
          <template slot-scope="scope">
            <div
              :class="
                `font-size-20 ${
                  validateSupportInfo(scope.row, versionItem) ? 'wsp-icon-yes bg-3bb113 ' : 'wsp-icon-no bg-f13131'
                }`
              "
            ></div>
          </template>
        </el-table-column>
      </template>
    </el-table>

    <el-drawer
      ref="drawer"
      :visible="dialogVisible"
      :modal-append-to-body="false"
      :modal="false"
      :append-to-body="false"
      size="55%"
      :before-close="handleCloseDrawer"
      direction="rtl"
      class="content-feature-drawer-detail"
    >
      <div style="margin: -70px 60px 0 10px" class="wsp-padding-tb-12">
        <div>
          <div
            style="background: #0052d9;margin: 12px 0;width: 6px;height: 31px;display: inline-block; margin-bottom: -10px;"
          ></div>
          <div style="display: inline-block; margin-bottom: 5px; margin-left: 8px;  font-size: large;">
            <template><span>功能描述</span> </template>
          </div>
        </div>
      </div>
      <div class="feature-detail-content">
        <el-tabs v-model="activeName">
          <el-tab-pane
            :name="versionItem.productVersion"
            v-for="(versionItem, index) in productFeatureList"
            :label="versionItem.productVersion"
            :key="index"
          >
            <div class="drawer-tips-content">
              <div class="feature-filed-detail-item">
                <div class="item-label">功能名：</div>
                <div class="item-value">{{ versionItem.featureName }}</div>
              </div>
              <div class="feature-filed-detail-item">
                <div class="item-label">功能类型：</div>
                <div class="item-value">
                  <template>
                    <el-tag v-if="versionItem.featureType === 'REQUIRED'" type="warning">{{
                      lang.t(featureTypeDictionary[versionItem.featureType]).label
                    }}</el-tag>
                    <el-tag v-else type="success">{{
                      lang.t(featureTypeDictionary[versionItem.featureType]).label
                    }}</el-tag>
                  </template>
                </div>
              </div>
              <div class="feature-filed-detail-item">
                <div class="item-label">业务诉求【主打价值】：</div>
                <div class="item-value">{{ versionItem.valueDesc }}</div>
              </div>
              <div class="feature-filed-detail-item">
                <div class="item-label">预期效果：</div>
                <div class="item-value">{{ versionItem.expectedOutcome }}</div>
              </div>
              <div class="feature-filed-detail-item" v-if="!isChannel">
                <div class="item-label">竞争力信息：</div>
                <div class="item-value">
                  <div v-for="(competitor, competitorIndex) in versionItem.competitiveList" :key="competitorIndex">
                    <span style="font-weight: bolder;">【友商：{{ competitor.competitorCn }}】</span>
                    <template>
                      <el-tag v-if="competitor.competitiveness === '优势'" type="success">
                        {{ competitor.competitiveness }}
                      </el-tag>
                      <el-tag v-else-if="competitor.competitiveness === '持平'" type="info">
                        {{ competitor.competitiveness }}
                      </el-tag>
                      <el-tag v-else type="danger"> {{ competitor.competitiveness }}</el-tag>
                    </template>
                    <span>{{ competitor.competitiveComparison }}</span>
                  </div>
                </div>
              </div>
              <div class="feature-filed-detail-item">
                <div class="item-label">测试说明：</div>
                <div class="item-value">{{ versionItem.schemeDesign }}</div>
              </div>
              <div class="feature-filed-detail-item" v-if="!isChannel">
                <div class="item-label">相关限制说明：</div>
                <div class="item-value">{{ versionItem.limitDesc }}</div>
              </div>
              <div class="feature-filed-detail-item">
                <div class="item-label">解决客户问题：</div>
                <div class="item-value">{{ versionItem.resolveIssues }}</div>
              </div>
              <div class="feature-filed-detail-item">
                <div class="item-label">价值描述：</div>
                <div class="item-value">{{ versionItem.configStep }}</div>
              </div>
              <div class="feature-filed-detail-item">
                <div class="item-label">视频演示：</div>
                <div class="item-value">{{ versionItem.video }}</div>
              </div>
              <div class="feature-filed-detail-item">
                <div class="item-label">PPT演示：</div>
                <div class="item-value">{{ versionItem.ppt }}</div>
              </div>
              <div class="feature-filed-detail-item">
                <div class="item-label">关联测试用例：</div>
                <div class="item-value">
                  <div v-for="item in versionItem.testCaseList" :key="item">
                    <span>{{ item.testCaseName }}</span>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  Button,
  Tag,
  Input,
  Drawer,
  CheckboxGroup,
  Checkbox,
  Dropdown,
  DropdownMenu,
  Tabs,
  TabPane,
  DropdownItem
} from 'element-ui'

import { action } from 'sky-engine/api/index'

import { COMMON_MNG } from '@/api/apiModules'
import { listSpecFeature, getFeatureByProductAndName } from '@/api/businessResearch'

import { relateProductVersion } from '@/api/scene'
import lang from '@/lang'
import dictionary from '@/utils/dictionary'
export default {
  name: 'SkyProductVersionSelectFunctionTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [Tag.name]: Tag,
    [Input.name]: Input,
    [Drawer.name]: Drawer,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane
  },
  props: {
    params: {
      type: Object,
      default: function() {
        return {}
      }
    },
    productId: {
      type: String,
      default: function() {
        return null
      }
    },
    selectFeatureIds: {
      type: Array,
      default: function() {
        return []
      }
    },
    projectCompetitors: {
      type: Array,
      default: function() {
        return []
      }
    },
    parentSelectVersionId: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  watch: {
    productId: {
      handler: function(newValue, oldValue) {
        this.selectALLFunction = []
        this.selectFunction = []
        if (this.selectFeatureIds) {
          this.defaultSelectFunction = this.selectFeatureIds
        }
        this.getProductVersion()
      }
    }
  },
  data: function() {
    return {
      activeName: null,
      searchKeyword: null,
      specFeatureList: [],
      viewFeatureList: [],
      valueDescList: [],
      sceneNameList: [],
      sceneMap: {},
      productVersionList: [],
      productVersionIdList: [],
      productFeatureList: [],
      selectVersionMap: {},
      defaultSelectFunction: [],
      selectFunction: [],
      selectALLFunction: [],
      dialogVisible: false,

      featureTypeDictionary: dictionary.featureType,
      lang: lang,
      reqParams: {
        matchArr: [],
        page: this.page - 1,
        limit: 1000
      },
      isChannel: this.$store.getters.baseInfo.channel,
      competitivenessList: [
        {
          text: '优势',
          value: '优势'
        },
        {
          text: '劣势',
          value: '劣势'
        },
        {
          text: '持平',
          value: '持平'
        },
        {
          text: '未知',
          value: '未知'
        }
      ],
      filterCompetitorList: [],
      initCompetitorList: [],
      formCompetitorList: [],
      featureProductCompetitiveMap: []
    }
  },
  created() {},
  mounted() {
    this.selectALLFunction = []
    this.selectFunction = []
    if (this.selectFeatureIds) {
      this.defaultSelectFunction = this.selectFeatureIds
    }
    this.getProductVersion()
    this.getInitCompetitorList()
  },
  methods: {
    handleFilterCompetitorList(checkedItems) {
      //最多3个，默认都有其他
      if (checkedItems.length > 3) {
        this.$store.dispatch('OpenNotification', { message: '友商过虑最多只能选择3个', type: 'warning' })
        checkedItems.pop()
        return
      }
      this.formCompetitorList = this.initCompetitorList.filter(one => checkedItems.includes(one.id))
      this.searchReq()
    },
    getCompetitivenessByFeatureAndProduct(competitor, featureName, productVersion, competitiveness) {
      const versionMap = this.featureProductCompetitiveMap[featureName]
      if (!versionMap || !versionMap[productVersion]) {
        return false
      }
      const findByCompetitor = competitor => {
        return versionMap[productVersion].find(item => item.competitor === competitor)
      }
      const competitive = findByCompetitor(competitor)
      if (!competitive) {
        return false
      }
      return competitiveness === competitive.competitiveness
    },
    filterFormCompetitors() {
      //必须返回的列表数据，否则不同功能，有不同的竞争信息，不一定都是相同列数的，所以直接固定
      //因此需要这里直接返回一个功能的固定友商的竞争数据
      let competitors = []

      competitors = this.initCompetitorList.filter(one => {
        if (this.filterCompetitorList) {
          return this.filterCompetitorList.includes(one.id)
        }
        return false
      })

      if (competitors && competitors.length >= 3) {
        competitors = competitors.splice(0, 2)
      }
      //默认有其他，前期数据过渡
      competitors.push({ id: 'OTHER', label: '其他' })
      this.formCompetitorList = competitors
      this.filterCompetitorList = competitors.map(item => {
        return item.id
      })
    },
    searchReq() {
      if (!this.searchKeyword) {
        this.viewFeatureList = this.specFeatureList
      } else {
        this.viewFeatureList = this.specFeatureList.filter(
          one => one.featureName.includes(this.searchKeyword) || one.valueDesc.includes(this.searchKeyword)
        )
      }
      this.reSelectFeature()
    },
    handleCloseDrawer() {
      this.productFeatureList = []
      this.dialogVisible = false
    },
    showFuncDetail(rowParams) {
      getFeatureByProductAndName({
        productIdList: this.productVersionIdList,
        featureName: rowParams.featureName
      }).then(res => {
        this.dialogVisible = true
        this.productFeatureList = res.data.content
        const [product] = this.productFeatureList
        this.activeName = product.productVersion
      })
    },
    validateSupportInfo(row, versionItem) {
      if (!row.productVersion) {
        return false
      }
      var support = false
      for (const supportVersion of row.productVersion) {
        if (supportVersion.id == versionItem.id) {
          support = true
          break
        }
      }
      return support
    },
    validateSupportInfoFatureId(row, versionItem) {
      if (!row.productVersion) {
        return null
      }
      var featureId = null
      for (const supportVersion of row.productVersion) {
        if (supportVersion.id == versionItem.id) {
          featureId = supportVersion.featureId
        }
      }
      return featureId
    },
    selectionChange(val, row) {
      this.handleSelectionChange(val, row)

      var selectIds = val.map(one => one.id)
      if (selectIds.includes(row.id)) {
        row.has_select = true
        if (!this.defaultSelectFunction.includes(row.id)) {
          this.defaultSelectFunction.push(row.id)
        }
      } else {
        row.has_select = false
        this.defaultSelectFunction = this.defaultSelectFunction.filters(one => one.id !== row.id)
      }
    },
    allSelectionChange(val) {
      var selectIds = val.map(one => one.id)
      for (const element of this.specFeatureList) {
        if (selectIds.includes(element.id)) {
          element.has_select = true
        } else {
          element.has_select = false
        }
        this.handleSelectionChange(val, element)
      }
      this.defaultSelectFunction = this.specFeatureList.filter(one => one.has_select).map(one => one.id)
    },
    selectAllChange(val) {
      if (val.length > 0) {
        this.allSelectionChange(val)
        var selectIds = val.map(one => one.id)
        this.defaultSelectFunction = selectIds
      }
      if (val.length == 0) {
        this.allSelectionChange([])
      }
    },
    handleSelectionChange(val, row) {
      var featureNameArr = this.getSelectFunction(val)
      if (featureNameArr.includes(row.featureName)) {
        // 存在
        var index_ex = this.selectFunction.indexOf(row.featureName)
        if (index_ex === -1) {
          this.selectFunction.push(row.featureName)
        }
        row.has_select = true
        // this.defaultSelectFunction.push(row.id)
        this.addAndValidateProductSupportInfo(row)
      } else {
        var index = this.selectFunction.indexOf(row.featureName)
        // 不存在
        this.removeAndValidateProductSupportInfo(row)
        if (index !== -1) {
          this.selectFunction.splice(index, 1)
        }
        // this.defaultSelectFunction = this.defaultSelectFunction.filters(one => one !== row.id)
        row.has_select = false
      }
      this.$emit(
        'changeSelect',
        JSON.parse(
          JSON.stringify({
            sceneList: this.params.sceneIdList,
            selectFunctionCount: this.selectFunction.length,
            totalFeatureCount: this.pageTotal,
            selectVersion: this.productVersionList
          })
        )
      )
    },
    selectableReq(row, index) {
      return row.featureType !== 'REQUIRED'
    },
    refreshTable() {
      this.getData()
    },
    removeAndValidateProductSupportInfo(row) {
      for (const version of this.productVersionList) {
        if (version.id === 'no_version_config') {
          continue
        }
        var versionMapValue = this.selectVersionMap[version.productVersion]

        if (this.validateSupportInfo(row, version)) {
          var selfeatureId = this.validateSupportInfoFatureId(row, version)
          if (versionMapValue.supportFeatureIds.indexOf(selfeatureId) !== -1) {
            versionMapValue.supportFeatureIds.splice(version.supportFeatureIds.indexOf(selfeatureId), 1)
          }
        } else {
          if (versionMapValue.unSupportFeatureids.indexOf(row.id) !== -1) {
            versionMapValue.unSupportFeatureids.splice(version.unSupportFeatureids.indexOf(row.id), 1)
          }
        }
      }
    },
    addAndValidateProductSupportInfo(row) {
      for (const version of this.productVersionList) {
        if (version.id === 'no_version_config') {
          continue
        }
        var versionMapValue = this.selectVersionMap[version.productVersion]
        if (this.validateSupportInfo(row, version)) {
          var selfeatureId = this.validateSupportInfoFatureId(row, version)
          if (versionMapValue.supportFeatureIds.indexOf(selfeatureId) === -1) {
            versionMapValue.supportFeatureIds.push(selfeatureId)
          }
        } else {
          if (versionMapValue.unSupportFeatureids.indexOf(row.id) === -1) {
            versionMapValue.unSupportFeatureids.push(row.id)
          }
        }
      }
    },
    getSelectFunction(selectArr) {
      var featureNameArr = []
      for (const iterator of selectArr) {
        featureNameArr.push(iterator.featureName)
      }
      return featureNameArr
    },
    filterCompetitiveness(value, row) {
      if (!row.competitiveness) {
        return false
      }
      return row.competitiveness === value
    },
    filterValueDesc(value, row) {
      if (!row.valueDesc) {
        return false
      }
      return row.valueDesc === value
    },
    filterSceneName(value, row) {
      var matchStatus = false
      for (const element of row.supportScene) {
        if (element.id === value) {
          matchStatus = true
          break
        }
      }
      return matchStatus
    },
    filterFeatureType(value, row) {
      if (!row.featureType) {
        return false
      }
      return row.featureType === value
    },
    buildSelectVersionMap() {
      this.productVersionIdList = []
      for (const element of this.productVersionList) {
        element.supportFeatureIds = []
        element.unSupportFeatureids = []
        this.productVersionIdList.push(element.id)
        this.selectVersionMap[element.productVersion] = element
      }
    },
    getProductVersion() {
      this.productVersionList = []
      relateProductVersion({
        sceneIdList: this.params.sceneIdList,
        series: this.productId,
        limitRelationProductIdList: this.parentSelectVersionId
      }).then(res => {
        this.productVersionList = res.data.content

        this.buildSelectVersionMap()
        this.$emit(
          'changeSelect',
          JSON.parse(
            JSON.stringify({
              sceneList: this.params.sceneIdList,
              selectFunctionCount: 0,
              totalFeatureCount: 0,
              selectVersion: this.productVersionList
            })
          )
        )
        this.getData()
      })
    },
    reloadData() {
      this.getData()
    },
    reSelectFeature() {
      this.$nextTick(() => {
        for (const iterator of this.specFeatureList) {
          if (this.defaultSelectFunction && this.defaultSelectFunction.length > 0) {
            if (this.defaultSelectFunction.includes(iterator.id)) {
              this.$refs.function_table.toggleRowSelection(iterator, true)
            }
          }
        }
      })
    },
    getData() {
      this.reqParams.matchArr = []
      this.reqParams.matchArr.push({
        type: 'EXACT',
        fieldName: 'sceneId',
        valueArr: this.params.sceneIdList,
        matchRule: 'EQ'
      })
      if (this.productVersionIdList && this.productVersionIdList.length > 0) {
        this.reqParams.matchArr.push({
          type: 'EXACT',
          fieldName: 'productId',
          valueArr: this.productVersionIdList,
          matchRule: 'EQ'
        })
      }

      if (this.searchKeyword) {
        this.reqParams.matchArr.push({
          type: 'FUZZY',
          fieldNameArr: ['featureName', 'valueDesc', 'productVersion', 'sceneName'],
          value: this.searchKeyword,
          matchRule: 'FULL'
        })
      }
      this.valueMap = {}
      listSpecFeature(this.reqParams).then(res => {
        var resList = res.data.content.itemArr
        this.featureProductCompetitiveMap = this.buildCompetitiveMap(resList)
        this.specFeatureList = this.compareProductFeature(res.data.content.itemArr)
        this.viewFeatureList = this.specFeatureList

        if (!this.searchKeyword) {
          this.pageTotal = this.specFeatureList.length
        }
        this.$nextTick(() => {
          for (const iterator of this.specFeatureList) {
            if (this.defaultSelectFunction && this.defaultSelectFunction.length > 0) {
              if (this.defaultSelectFunction.includes(iterator.id)) {
                this.$refs.function_table.toggleRowSelection(iterator)
                iterator.has_select = true
                this.selectFunction.push(iterator.featureName)
                this.addAndValidateProductSupportInfo(iterator)
              }
            } else {
              if (iterator.featureType === 'RECOMMEND' || iterator.featureType === 'REQUIRED') {
                this.$refs.function_table.toggleRowSelection(iterator)
                iterator.has_select = true
                this.selectFunction.push(iterator.featureName)
                this.addAndValidateProductSupportInfo(iterator)
              }
            }
          }

          var idArr = []
          for (const element of this.specFeatureList) {
            if (element.has_select) {
              idArr.push(element.id)
            }
          }
          this.defaultSelectFunction = idArr

          this.$emit(
            'changeSelect',
            JSON.parse(
              JSON.stringify({
                sceneList: this.params.sceneIdList,
                selectFunctionCount: this.selectFunction.length,
                totalFeatureCount: this.pageTotal,
                selectVersion: this.productVersionList
              })
            )
          )

          this.defaultSelectFunction = idArr

          for (const element of resList) {
            if (!this.valueMap[element.valueDesc]) {
              this.valueMap[element.valueDesc] = {
                text: element.valueDesc,
                value: element.valueDesc
              }
            }

            if (!this.sceneMap[element.sceneId]) {
              this.sceneMap[element.sceneId] = {
                text: element.sceneName,
                value: element.sceneId
              }
            }
          }

          if (!this.searchKeyword) {
            this.valueDescList = []
            for (var iterator in this.valueMap) {
              this.valueDescList.push(this.valueMap[iterator])
            }
            this.sceneNameList = []
            for (var sceneItem in this.sceneMap) {
              this.sceneNameList.push(this.sceneMap[sceneItem])
            }
          }
        })
      })
    },
    buildCompetitiveMap(specFeatureList) {
      const featureMap = {}
      specFeatureList.forEach(feature => {
        if (feature.sceneId && feature.productId) {
          const featureName = feature.featureName

          if (!featureMap[featureName]) {
            const versionMap = {}
            versionMap[feature.productVersion] = feature.competitiveList
            featureMap[featureName] = versionMap
          } else {
            const versionMap = featureMap[featureName]
            if (!versionMap[feature.productVersion]) {
              versionMap[feature.productVersion] = feature.competitiveList
            }
          }
        }
      })

      return featureMap
    },
    compareProductFeature(specFeatureList) {
      const featureMap = {}
      specFeatureList.forEach(feature => {
        if (feature.sceneId && feature.productId) {
          const featureName = feature.featureName
          if (!featureMap[featureName]) {
            featureMap[featureName] = feature
            featureMap[featureName].supportScene = []
            featureMap[featureName].productVersion = []
          }
          featureMap[featureName].supportScene.push({
            id: feature.sceneId,
            name: feature.sceneName
          })
          featureMap[featureName].productVersion.push({
            id: feature.productId,
            featureId: feature.id
          })
        }
      })

      const featureList = Object.keys(featureMap).map(key => {
        return featureMap[key]
      })
      return featureList
    },
    getInitCompetitorList() {
      if (!this.isChannel) {
        action(COMMON_MNG, 'projectCompetitor').then(response => {
          this.initCompetitorList = response.data.content.itemArr.map(item => {
            return {
              id: item.id,
              label: item.label
            }
          })
          //过滤条件选中默认项目中的友商
          this.filterCompetitorList = this.projectCompetitors
          this.filterFormCompetitors()
        })
      }
    }
  }
}
</script>

<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(page-function-view) {
  height: 100%;
  .page-function-toolbar {
    .toolbar-input {
      width: 39%;
    }
    .toolbar-left {
      float: left;
    }
    .toolbar-right {
      float: right;
    }
  }
  .el-table .cell {
    padding-left: 3px;
  }
  .el-dropdown-menu {
    width: 20px;
  }
  .el-checkbox-group {
    margin-left: 10px;
  }
  .content-feature-drawer-detail {
    height: 100%;

    .feature-detail-content {
      padding: 12px 20px;
      overflow-y: auto;
      height: 86vh;
      .feature-filed-detail-item {
        display: flex;
        line-height: 28px;
        .item-label {
          text-align: right;
          font-weight: 600;
          width: 18%;
        }
        .item-value {
          width: 80%;
          word-break: break-all;
          white-space: pre-wrap;
          .item-tag {
            margin: 0 3px;
          }
        }
      }
    }
  }
}
</style>
